/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customerWalletShow } from '../../axios/customerWalletShow'
import type {
	CustomerWalletShowError,
	CustomerWalletShowPathParams,
	CustomerWalletShowResponse,
} from '../../types/CustomerWalletShow'

export const customerWalletShowQueryKey = (organisation: CustomerWalletShowPathParams['organisation']) =>
	[{ url: '/:organisation/wallet', params: { organisation } }] as const

export type CustomerWalletShowQueryKey = ReturnType<typeof customerWalletShowQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::show */
export function customerWalletShowQueryOptions(
	organisation: CustomerWalletShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomerWalletShowResponse,
		AxiosError<CustomerWalletShowError>,
		CustomerWalletShowResponse,
		CustomerWalletShowQueryKey
	>({
		queryKey: customerWalletShowQueryKey(organisation),
		queryFn: ({ signal }) => customerWalletShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::show */
export function useCustomerWalletShow<TSelectData = CustomerWalletShowResponse>(
	organisation: CustomerWalletShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomerWalletShowResponse,
					AxiosError<CustomerWalletShowError>,
					TSelectData,
					CustomerWalletShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomerWalletShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customerWalletShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::show */
export function useCustomerWalletShowSuspense<TSelectData = CustomerWalletShowResponse>(
	organisation: CustomerWalletShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomerWalletShowResponse,
					AxiosError<CustomerWalletShowError>,
					TSelectData,
					CustomerWalletShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomerWalletShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customerWalletShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
